export default __webpack_public_path__ + "static/media/12.ffa1a2d7.jpg";